import React, {useContext} from "react";
import './popup.scss';
import { AiFillCloseCircle } from 'react-icons/ai';
import {CountContext} from "../../CountContext";



export function Popup(props) {


    return(props.trigger) ? (
        <div className="popup">
            <div className="popup-container">
                <div className="div-top">
                    <h3>Cart</h3>
                    <button onClick={() => props.setTrigger(false)} className="close-btn"><AiFillCloseCircle /></button>

                </div>

                <div className="popup-inner">
                    { props.children }
                </div>
            </div>

        </div>
    ) : ""
}
